import { LoadingIndicator } from '../../common/components/loading-indicator';
import { useIntegratedForm } from '../use-integrated-form';

export function FormLoadingIndicator(): React.ReactElement {
    const integratedForm = useIntegratedForm();
    return integratedForm.query.isInitialLoading ? <LoadingIndicator /> : <></>;
}
